import { render } from "./Extratos.vue?vue&type=template&id=a3da37e8&scoped=true"
import script from "./Extratos.vue?vue&type=script&lang=js"
export * from "./Extratos.vue?vue&type=script&lang=js"

import "./Extratos.vue?vue&type=style&index=0&id=a3da37e8&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a3da37e8"]])

export default __exports__